import { SAMPLE_CAMPAIGN_RICHTEXT_FIELDS } from './sampleCampaignContent.js'

export const baseTemplateParams = {
  headerBgColor: '#ffffff',
  logoUrl: '',
  heroImgUrl: '',
  heroImg2: '',
  heroImg3: '',
  heroImg4: '',
  heroAnimatedImgUrl: '',
  heroImageLinkUrl: '',
  preheaderText: 'This text will appear next to your subject line in the inbox.',
  subject: 'Your next stay awaits',
  headerTaglineScript: '',
  headerTaglineSans: '',
  heroOverlayText: '',
  footerAccentColor: '#182852',
  discoverIntroText: 'Choose your escape.',
  emailTitle: 'Your Next Stay Awaits',
  ctaText: 'Book your next stay',
  secondaryCtaText: 'View special offers',
  secondaryCtaUrl: '#',
  ctaUrl: '#',
  ctaBackgroundColor: '#2563eb',
  ctaTextColor: '#ffffff',
  col1Image: '',
  col1ImageLinkUrl: '',
  col1LinkText: 'Learn more →',
  col1LinkUrl: '#',
  col2Image: '',
  col2ImageLinkUrl: '',
  col2LinkText: 'Learn more →',
  col2LinkUrl: '#',
  col3Image: '',
  col3ImageLinkUrl: '',
  col3LinkText: 'Learn more →',
  col3LinkUrl: '#',
  featuresSectionKicker: 'Exclusive experiences',
  featuresSectionTitle: 'Curated for your stay',
  discoverBtn1: 'Dining',
  discoverBtn1LinkUrl: '#',
  discoverBtn2: 'Spa & wellness',
  discoverBtn2LinkUrl: '#',
  discoverBtn3: 'Golf',
  discoverBtn3LinkUrl: '#',
  discoverBtn4: 'Local experiences',
  discoverBtn4LinkUrl: '#',
  galleryKicker: 'Discover',
  galleryTitle: 'Explore the resort',
  galleryCaption1: 'Pool & terrace',
  galleryCaption2: 'Signature dining',
  galleryCaption3: 'Spa sanctuary',
  galleryCaption4: 'Guest suites',
  gallery1Image: '',
  gallery1ImageLinkUrl: '',
  gallery2Image: '',
  gallery2ImageLinkUrl: '',
  gallery3Image: '',
  gallery3ImageLinkUrl: '',
  gallery4Image: '',
  gallery4ImageLinkUrl: '',
  lifestyleImage: '',
  lifestyleImageLinkUrl: '',
  lifestyleImageAlt: 'Property lifestyle image',
  socialQuote: '"An unforgettable stay — we cannot wait to return."',
  socialAuthor: 'Sarah M.',
  socialGuestImage: '',
  socialGuestImageLinkUrl: '',
  experiencesKicker: 'Membership amenities',
  exp1Title: 'Racquet sports',
  exp1Desc: '',
  exp1Image: '',
  exp1ImageLinkUrl: '',
  exp2Title: 'Spa',
  exp2Desc: '',
  exp2Image: '',
  exp2ImageLinkUrl: '',
  exp3Title: 'Golf',
  exp3Desc: '',
  exp3Image: '',
  exp3ImageLinkUrl: '',
  exp4Title: 'Fitness center',
  exp4Image: '',
  exp4ImageLinkUrl: '',
  offerKicker: 'Preferred availability',
  offerTitle: 'Weekend escapes',
  offerBody: 'Select dates remain open for direct bookings.',
  offerDate1: 'July 11–13',
  offerDate2: 'July 25–27',
  offerDate3: 'August 8–10',
  hotelName: '',
  hotelAddress: '',
  hotelCityStateZip: '',
  privacyPolicyUrl: '#',
  termsUrl: '#',
  socialMediaLinks: [
    { platform: 'facebook', url: '#' },
    { platform: 'twitter', url: '#' },
    { platform: 'instagram', url: '#' },
    { platform: 'linkedin', url: '#' },
    { platform: 'youtube', url: '#' }
  ],
  logoWidth: '60px',
  logoHeight: '60px',
  richtextFields: {
    ...SAMPLE_CAMPAIGN_RICHTEXT_FIELDS
  }
}

export default baseTemplateParams
